import type { Language } from '@posilka/shared';

/** Asia/Tashkent = UTC+5, DST yo'q (SPEC §15: bazada UTC, ko'rsatishda Toshkent). */
const OFFSET_MS = 5 * 60 * 60 * 1000;

const pad = (n: number) => String(n).padStart(2, '0');

/** UTC ISO → Toshkent bo'yicha `{ date: 'YYYY-MM-DD', time: 'HH:mm' }`. */
export function toTashkent(iso: string | Date): { date: string; time: string } {
  const d = new Date(new Date(iso).getTime() + OFFSET_MS);
  return {
    date: `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`,
    time: `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`,
  };
}

/** Toshkent sanasi + vaqti → UTC ISO. */
export function fromTashkent(date: string, time: string): string {
  const [y, m, d] = date.split('-').map(Number);
  const [hh, mm] = time.split(':').map(Number);
  return new Date(Date.UTC(y!, m! - 1, d!, hh!, mm!) - OFFSET_MS).toISOString();
}

export const todayTashkent = (now = new Date()) => toTashkent(now).date;

export const addDays = (date: string, days: number) => {
  const [y, m, d] = date.split('-').map(Number);
  const t = new Date(Date.UTC(y!, m! - 1, d! + days));
  return `${t.getUTCFullYear()}-${pad(t.getUTCMonth() + 1)}-${pad(t.getUTCDate())}`;
};

/** ICU'da uz-UZ oy nomlari yo'q ("M09" chiqadi) — qo'lda. */
const MONTHS: Record<Language, string[]> = {
  uz: ['yan', 'fev', 'mar', 'apr', 'may', 'iyn', 'iyl', 'avg', 'sen', 'okt', 'noy', 'dek'],
  ru: ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
};

const formatDay = (iso: string | Date, lang: Language) => {
  const { date } = toTashkent(iso);
  const [, m, d] = date.split('-').map(Number);
  return `${d} ${MONTHS[lang]?.[m! - 1] ?? MONTHS.uz[m! - 1]}`;
};

export function formatDateTime(iso: string, lang: Language): string {
  return `${formatDay(iso, lang)}, ${toTashkent(iso).time}`;
}

/** `25 sen, 09:00–13:00` — bir kunlik oraliq uchun ixcham ko'rinish. */
export function formatWindow(fromIso: string, toIso: string, lang: Language): string {
  const from = toTashkent(fromIso);
  const to = toTashkent(toIso);
  return from.date === to.date
    ? `${formatDay(fromIso, lang)}, ${from.time}–${to.time}`
    : `${formatDateTime(fromIso, lang)} – ${formatDateTime(toIso, lang)}`;
}

/** Hozirdan keyingi to'liq soat (Toshkent), `HH:00`; 23 dan keyin — 23:00. */
export const nextHourTashkent = (now = new Date()) => {
  const h = Math.min(23, Number(toTashkent(now).time.slice(0, 2)) + 1);
  return `${pad(h)}:00`;
};
